module.exports = __webpack_public_path__ + "static/media/eg.a4f0de03.webp";